import { render, staticRenderFns } from "./Authorization.vue?vue&type=template&id=e65af0e6&scoped=true"
import script from "./Authorization.vue?vue&type=script&lang=js"
export * from "./Authorization.vue?vue&type=script&lang=js"
import style0 from "./Authorization.vue?vue&type=style&index=0&id=e65af0e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e65af0e6",
  null
  
)

export default component.exports